import { createRequest } from 'mk-biz-pc'
import { Config } from './config'

const coreApi = createRequest('core')

/**
 * 获取消息列表
 */
export const getMessage = () => coreApi(Config.getMessageList)

/**
 * 获取消息未读数量
 * @returns
 */
export const getUnReadMessageCount = () => coreApi(Config.getUnReadMessageCount)
